export default "__VITE_ASSET__DgXn0Y7M__"